"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var storybook_1 = require("@eyecons/storybook");
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
function List(_a) {
    var comments = _a.comments, setComments = _a.setComments, user = _a.user, video = _a.video;
    var _b = ra_fetch_1.useApi('media')
        .records(setComments, comments.data, 'id', 'id')
        .delete('comments', { video_id: video.external_id }), deleteComments = _b[0], submitDeleteComments = _b[1];
    return react_1.default.createElement(react_1.default.Fragment, null, comments.data
        .sortBy('created_at', 'desc')
        .map(function (comment, index) {
        var canDelete = comment.user_id === user.id || user.permissions.includes('media.comments.destroy');
        return react_1.default.createElement("div", { key: index, className: "flex storybook-comments-list " + (comment.user_id === user.id ? 'owned' : '') },
            canDelete &&
                react_1.default.createElement("div", { className: 'storybook-comments-list-trash', onClick: function () { return submitDeleteComments({ id: comment.id }); } },
                    react_1.default.createElement(storybook_1.Icons.Icon, { name: 'trash', className: 'storybook-icons-icon cursor-pointer mx-auto' })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: 'flex gap-1 items-baseline' },
                    react_1.default.createElement(storybook_1.Texts.Primary, null, comment.name),
                    react_1.default.createElement(storybook_1.Texts.Small, { className: 'text-gray-500' }, storybook_1.Helpers.uploadTime(comment.created_at))),
                react_1.default.createElement(storybook_1.Texts.Primary, null, comment.text)));
    }));
}
exports.default = List;
